var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Remove } from "../Remove";
import { Icon } from "sb-resp-ui";
var Market = /** @class */ (function (_super) {
    __extends(Market, _super);
    function Market() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Market.prototype.render = function () {
        return (React.createElement("div", { className: "rj-yourbet__market" },
            React.createElement("div", { className: "rj-yourbet__market-details" },
                React.createElement("p", { className: "rj-yourbet__market-title" }, this.props.title),
                React.createElement("p", { className: "rj-yourbet__market-type" }, this.props.market)),
            this.props.handler && React.createElement(Remove, { icon: "i-16 i-o-yourbet-trash", datauat: "i-o-trash", handler: this.props.handler }),
            this.props.isSuspended &&
                React.createElement("div", { className: "rj-yourbet__suspended-overlay", onClick: this.props.handler },
                    React.createElement("div", { className: "rj-yourbet__suspended-overlay-label" },
                        React.createElement(Icon, { i: "i-o-yourbet-close" }),
                        React.createElement("span", { className: "rj-yourbet__suspended-overlay-text" }, this.props.suspendedTxt)))));
    };
    return Market;
}(React.Component));
export { Market };
//# sourceMappingURL=Market.js.map